import { Magnetic as Mi } from "../../../styles";
export const GROUP_NAME_PADDING_LEFT = Mi.spacer08;
//# sourceMappingURL=Constants.js.map